import { Component, type ReactNode } from 'react';
import { AlertTriangle } from 'lucide-react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export default class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center min-h-[60vh] px-6 text-center">
          <div className="w-16 h-16 bg-night-100 rounded-full flex items-center justify-center mb-6">
            <AlertTriangle size={28} className="text-night-500" />
          </div>
          <h2 className="text-2xl font-black uppercase text-night-950 mb-3">
            Something went wrong
          </h2>
          <p className="text-night-500 mb-8 max-w-md">
            An unexpected error occurred. Please refresh the page or navigate back to the homepage.
          </p>
          <a href="/" className="btn-primary">
            Go to homepage
          </a>
        </div>
      );
    }

    return this.props.children;
  }
}
